/**
 * @name APP u-planning
 * @autor jaime.salazar@u-planner.com
 * @description
 * rutas modulo tablas de datos cargados
 */

//Inyectamos la dependencias necesarias de angular para generar las rutas;

routes.$inject = ['$stateProvider', '$urlRouterProvider', '$locationProvider'];

//funcion donde se definen la rutas

export default function routes($stateProvider, $urlRouterProvider, $locationProvider) {
	
  $stateProvider
    .state('app.table_institucion', {
      url: '/table_institucion?type',
      abstract: false,
      template: require('./table.html'),
      controller: 'tableCtrl',
      controllerAs: 'table'  
    })
    .state('app.table_campus', {
      url: '/table_campus?type',
      abstract: false,
      template: require('./table.html'),
      controller: 'tableCtrl',
      controllerAs: 'table'  
    }).state('app.table_periodo', {
      url: '/table_periodo?type',
      abstract: false,
      template: require('./table.html'),
      controller: 'tableCtrl',
      controllerAs: 'table'  
    }).state('app.table_jornada', {
      url: '/table_jornada?type',
      abstract: false,
      template: require('./table.html'),
      controller: 'tableCtrl',
      controllerAs: 'table'  
    }).state('app.table_modulos_jornada', {
      url: '/table_modulos_jornada?type',
      abstract: false,
      template: require('./table.html'),
      controller: 'tableCtrl',
      controllerAs: 'table'  
    }).state('app.table_planes_campus', {
      url: '/table_planes_campus?type',
      abstract: false,
      template: require('./table.html'),
      controller: 'tableCtrl',
      controllerAs: 'table'  
    }).state('app.table_carrera', {
      url: '/table_carrera?type',
      abstract: false,
      template: require('./table.html'),
      controller: 'tableCtrl',
      controllerAs: 'table'  
    }).state('app.table_plan_estudio', {
      url: '/table_plan_estudio?type',
      abstract: false,
      template: require('./table.html'),
      controller: 'tableCtrl',
      controllerAs: 'table'  
    }).state('app.table_materia_plan', {
      url: '/table_materia_plan?type',
      abstract: false,
      template: require('./table.html'),
      controller: 'tableCtrl',
      controllerAs: 'table'  
    }).state('app.table_departamento', {
      url: '/table_departamento?type',
      abstract: false,
      template: require('./table.html'),
      controller: 'tableCtrl',
      controllerAs: 'table'  
    }).state('app.table_materia_departamento', {
      url: '/table_materia_departamento?type',
      abstract: false,
      template: require('./table.html'),
      controller: 'tableCtrl',
      controllerAs: 'table'  
    }).state('app.table_actividad', {
      url: '/table_actividad?type',
      abstract: false,
      template: require('./table.html'),
      controller: 'tableCtrl',
      controllerAs: 'table'  
    }).state('app.table_nota_clase', {
      url: '/table_nota_clase?type',
      abstract: false,
      template: require('./table.html'),
      controller: 'tableCtrl',
      controllerAs: 'table'  
    });
}


// WEBPACK FOOTER //
// ./src/app/integration-front/tables/tables.route.js